export default __webpack_public_path__ + "static/media/02.bab113c4.jpg";